export default __webpack_public_path__ + "static/media/bigNum.2bb466c5.jpg";